// Initialize Strava namespace
const root = window;
root.Strava = root.Strava || {};

window.Strava.module = function(pkg) {
  const packageMembers = pkg.split(".");
  let level = window;

  packageMembers.forEach((value) => {
    level[value] = level[value] || {};
    level = level[value];
  });
};

export default window.Strava;
